import { Link } from "gatsby"
import React, { memo, useCallback, useEffect, useRef, useState } from "react"
import styled from "styled-components"

const Container = styled.header`
  background-color: var(--black);
  color: var(--white);
  display: grid;
  grid-template: auto auto / 1fr 1fr;
  padding: var(--gutter-s) var(--gutter-s);
  z-index: 9;
  @media (min-width: 768px) {
    grid-template: auto / 200px 1fr;
    padding: var(--gutter-s) var(--gutter-l);
  }
`

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  img {
    width: auto;
    max-height: 50px;
  }
  @media (min-width: 768px) {
  }
`

const Icon = styled.div`
  justify-self: end;
  display: flex;
  align-items: center;
  svg {
    path {
      fill: var(--white);
    }
  }
  @media (min-width: 768px) {
    display: none;
  }
`

const Menu = styled.div`
  grid-row: 2 / 3;
  grid-column: 1 / 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 0;
  height: 0;
  overflow: hidden;
  transition: 250ms ease-out;
  box-shadow: 0px 4px 6px -6px var(--black);
  li {
    display: flex;
    align-items: center;
    list-style: none;
    min-height: 50px;
    width: 100%;
    a {
      display: inline-block;
      text-align: center;
      width: 100%;
    }
  }
  &.open {
    min-height: calc(50px * 3);
  }
  @media (min-width: 768px) {
    grid-row: 1 / 2;
    grid-column: 2 / 3;
    justify-self: end;
    flex-direction: row;
    height: auto;
    min-height: auto;
    box-shadow: 0px 0px 0px 0px var(--black);
    li {
      min-height: auto;
      padding: 0 1rem;
      width: auto;
      a {
        &:after {
        }
        &:hover {
        }
      }
    }
  }
`

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [frameId, setFrameId] = useState(null)

  const menu = useRef(null)

  const onResize = useCallback(() => {
    setFrameId(window.requestAnimationFrame(breakpointCollapse))
  }, [])

  const breakpointCollapse = () => {
    if (document.body.getBoundingClientRect().width < 768) {
      menu.current.classList.remove("open")
    }
  }

  const toggleMenu = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    window.addEventListener("resize", onResize, false)
    return function cleanup() {
      window.removeEventListener("resize", onResize, false)
      window.cancelAnimationFrame(frameId)
    }
  }, [frameId, onResize])

  return (
    <Container>
      <Logo to="/">2019</Logo>
      <Icon onClick={toggleMenu}>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 18c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3zm0-9c1.657 0 3 1.343 3 3s-1.343 3-3 3-3-1.343-3-3 1.343-3 3-3z" />
        </svg>
      </Icon>
      <Menu ref={menu} className={isOpen ? "open" : null}>
        <li>
          <Link to="/"> Home </Link>
        </li>
        <li>
          <Link to="/library"> Library </Link>
        </li>
      </Menu>
    </Container>
  )
}

export default memo(Header)
